import React from 'react';
import PropTypes from 'prop-types';

import { ExternalLinkProvider } from '../../context/ExternalLink';

import FooterSimplified from './FooterSimplified';

const FooterSimplifiedContainer = ({ locales, localeToggle, ...restProps }) => (
  <ExternalLinkProvider
    currentLocale={locales.current}
    localeToggle={localeToggle}
  >
    <FooterSimplified locales={locales} {...restProps} />
  </ExternalLinkProvider>
);

FooterSimplifiedContainer.propTypes = {
  locales: PropTypes.shape({
    current: PropTypes.string
  }).isRequired,
  localeToggle: PropTypes.shape({
    chinese: PropTypes.bool
  })
};

FooterSimplifiedContainer.defaultProps = {
  localeToggle: {}
};

export default FooterSimplifiedContainer;
